<template>
  <div class="category-form-container">
    <v-dialog v-model="dialog" max-width="500px" @click:outside="clearData">
      <template v-slot:activator="{ attrs }">
        <v-btn color="success" class="mb-2" v-bind="attrs" @click="toggleDialog"
          >+ เพิ่มประเภทสินค้า</v-btn
        >
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">{{ modalTitle }}ประเภทสินค้า</span>
        </v-card-title>

        <v-card-text class="modal-card-text">
          <v-container>
            <v-form ref="form">
              <v-text-field
                v-model="formData.name"
                label="ชื่อประเภทสินค้า*"
                outlined
                dense
                :rules="[rules.required]"
              />
            </v-form>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="clearData">ปิดหน้าต่าง</v-btn>
          <v-btn color="success" @click="submitForm" :disabled="validate"
            >บันทึก</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { cloneDeep, findIndex, isEmpty, get } from "lodash";
import Utils from "@/mixin";

export default {
  computed: {
    validate() {
      const { name } = this.formData;
      if (isEmpty(name)) {
        return true;
      } else {
        return false;
      }
    },
  },
  data: () => ({
    modalTitle: "เพิ่ม",
    initialForm: {
      name: "",
    },
    formData: {
      name: "",
    },
    rules: {
      required: (value) => !!value || "กรุณากรอกข้อมูล",
    },
  }),
  methods: {
    clearData() {
      if (this.$props.editId !== "") this.$props.setInitialDialog();
      this.toggleDialog();
      this.$nextTick(() => {
        this.modalTitle = "เพิ่ม";
        const cloneInit = cloneDeep(this.initialForm);
        this.formData = Object.assign({}, cloneInit);
        if (this.$refs.form) this.$refs.form.resetValidation();
      });
    },
    submitForm() {
      const { formData } = this;
      if (this.$props.editId !== "") {
        const submitForm = {
          name: get(formData, "name"),
          id: this.$props.editId,
        };
        this.editProductType(submitForm);
      } else {
        const submitForm = {
          name: get(formData, "name"),
        };
        this.createProductType(submitForm);
      }
      this.clearData();
    },
  },
  mixins: [Utils],
  props: {
    editId: {
      type: [Number, String],
      default: "",
    },
    dialog: {
      type: Boolean,
      default: false,
    },
    toggleDialog: {
      type: Function,
      default: () => {},
    },
    setInitialDialog: {
      type: Function,
      default: () => {},
    },
  },
  watch: {
    editId(nextProps, prevProps) {
      if (prevProps !== nextProps && nextProps !== "") {
        this.modalTitle = "แก้ไข";
        const producttypes = this.producttypes?.data || [];
        const index = findIndex(producttypes, (i) => i.id === this.editId);

        if (index !== -1) {
          const data = producttypes[index];
          this.formData = {
            name: data.name,
          };
        }
      }
    },
  },
};
</script>